import React, { useEffect, useState } from "react";
import t from '../skillTranslations';
import getIcon from "../getIcon";
const Job = ({ jobId, desktopView }) => {
  const [job, setJob] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mustHave, setMustHave] = useState([]);
  const [niceToHave, setNiceToHave] = useState([]);
  const [hasYouTube, setHasYouTube] = useState(false);
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
  useEffect(() => {
    const fetchJobDetail = async () => {
      try {
        const response = await fetch(api_endpoint + `/api/jobs/${jobId}`);
        const data = await response.json();

        setJob(data); // Set the fetched job data
        setIsLoading(false); // Set loading to false once data is fetched
        if (data.youtube) {
          setHasYouTube(true);
        }
        // Separate requirements into must-have and nice-to-have, grouped by type
        const mustHaveReq = [];
        const niceToHaveReq = [];

        // Group skills by type
        data.requirements.forEach(requirement => {
          requirement.skills.forEach(skill => {
            if (skill.required === 1) {
              // Add to mustHave grouped by skill type
              const existingGroup = mustHaveReq.find(group => group.type === requirement.type);
              if (existingGroup) {
                existingGroup.skills.push(skill);
              } else {
                mustHaveReq.push({ type: requirement.type, skills: [skill] });
              }
            } else if (skill.required === 0) {
              // Add to niceToHave grouped by skill type
              const existingGroup = niceToHaveReq.find(group => group.type === requirement.type);
              if (existingGroup) {
                existingGroup.skills.push(skill);
              } else {
                niceToHaveReq.push({ type: requirement.type, skills: [skill] });
              }
            }
          });
        });

        setMustHave(mustHaveReq);  // Set the must-have skills grouped by type
        setNiceToHave(niceToHaveReq);  // Set the nice-to-have skills grouped by type
      } catch (error) {
        setError("Failed to fetch job details");
        setIsLoading(false);
      }
    };

    if (jobId) {
      fetchJobDetail(); // Fetch job details when jobId changes
    }
  }, [jobId]);


  if (isLoading) {
    return <div>Pillanat...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      {/* Black header section */}
      <div className="second-header">
        <img
          src={job.logo}
          alt={`${job.company} logo`}
          className="job-company-logo"
        />
        <h2 className="job-title">{job.name}</h2>
      </div>
      <div className={desktopView ? "job-page" : ""}>
      {/* Job description */}
      <div className={desktopView ? "job-page__left": ""}>
      <div className="job-description">
        <h3 className="skill-group-h3">Leírás</h3>
        <p>{job.description || "No description provided."}</p>
      </div>
      {hasYouTube && (
        <div className="youtube-section">
          <h3 className="skill-group-h3">Bemutatkozó videó</h3>
          <div className="youtube-player">
            <iframe 
              width="100%" 
              height="315" 
              src={`https://www.youtube.com/embed/${job.youtube}`} 
              frameBorder="0" 
              allowFullScreen
            />
          </div>
        </div>
      )}
      </div>
      <div className={desktopView ? "job-page__right" : ""}>
      <div className={desktopView ? "inner-scroll-container" : ""}>
      <div className="job-skills">
      {job.min_salary || job.max_salary ? (
  <div className="job-skills">
    <div className="group-icon">
      <h3>{t["salary"]}</h3>
      <div className="skill-icon">{getIcon("salary")}</div>
    </div>
    <div className="skills-chips">
      <span key={0} className="chip">
        {job.min_salary}{job.max_salary ? '-' + job.max_salary : ''}
      </span>
    </div>
  </div>
): null}


      {/* Required Skills Section */}
      {mustHave.length > 0 && (
        <>
          <h3 className="skill-group-h3">Elvárt készségek</h3>
          {mustHave.map((group, index) => (
            <div key={index} className="skill-group">
              <div className="group-icon">
                <h4>{t[group.type]}</h4>
                <div className="skill-icon">{getIcon(group.type)}</div>
                </div>
              <div className="job-chips">
                {group.skills.map((skill, skillIndex) => (
                  <span key={skillIndex} className="chip">
                    {skill.name}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </>
      )}

      {/* Nice to Have Skills Section */}
      {niceToHave.length > 0 && (
        <>
          <h3 className="skill-group-h3">Előnyt jelentő készségek</h3>
          {niceToHave.map((group, index) => (
            <div key={index} className="skill-group">
              <div className="group-icon">
                <h4>{t[group.type]}</h4>
                <div className="skill-icon">{getIcon(group.type)}</div>
                </div>
              <div className="job-chips">
                {group.skills.map((skill, skillIndex) => (
                  <span key={skillIndex} className="chip">
                    {skill.name}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </>
      )}
      </div>
      </div>
      </div>
      </div>
    </div>
  );
};

export default Job;
